module.exports = __webpack_public_path__ + "img/github-logo.911b950e.svg";